import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'
import { IomService } from '../../services/iom.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { SessionService } from 'src/app/services/session.service';
import { AppConfigService } from 'src/app/services/app-config.service';
declare var userNotification: any;


@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {
  userType: number;
  envData: any;

  constructor(private router: Router, private sessionservice: SessionService, private appConfigService: AppConfigService) {
    this.envData = this.appConfigService.getEnvironment();
  }

  ngOnInit(): void {
    console.log("ENTERED LANDING PAGE")
    this.userType = parseInt(this.sessionservice.getSessionStorageItem('userType'));    
  }

  initializeUserNotificationContent(): void {
    const content = {
      DataSourceUId: "00100000-0010-0000-0000-000000000000",
      TemplateUId: "00200000-0010-0000-0000-000000000000",
      ServiceUrl: "usernotification/UserNotification.json",
      ActiveLanguage: "en-US"//sessionStorage.getItem('Culture')
    }
    userNotification.init(content);
  }

  navigateToDeepdive() {
    setTimeout(() => {
      if (parseInt(this.sessionservice.getSessionStorageItem('userType')) == 1) {
        $('#standScope').hide();
        if(this.envData.Env == "FDS_ManualUpload")
        this.router.navigate(['proposalsummary']); 
        else
        this.router.navigate(['createproposal']);
      } else {
        $('#standScope').hide();
        if (this.envData.instanceType == 'PAM' || sessionStorage.getItem("Instance") == "PAM")
          this.router.navigate(['deepdive'], { queryParamsHandling: "merge" });
          else
          this.router.navigate(['proposalsummary']); 
      }
    }, 1000);
  }
}
